import React, { useState } from "react";
import { amlAdminWithDev } from "../../../shared/ClaimLists/Claim.Aml.All.List";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@material-ui/core";
import ClaimsWrapper from "../../../shared/ui/Claim.Wrapper";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import { amlStatuses } from "../amlStatuses";
import { painBanks } from "../painBanks";

export const AmlWarningsActions = ({
  value,
  investorDepositId,
  setAmlWarningStatus,
  setAmlWarningStatusAndCreateSendBackOrder,
  includeBankAccount = false,
}) => {
  const [showActionDialog, setShowActionDialog] = useState(false);
  const [status, setStatus] = useState("");
  const [note, setNote] = useState("");
  const [bankAccount, setBankAccount] = useState("");
  const [bankName, setBankName] = useState("");

  return (
    <ClaimsWrapper claimAuth={amlAdminWithDev}>
      <Button
        variant="outlined"
        className="aml-button"
        onClick={() => setShowActionDialog(true)}
        color="primary"
      >
        SET STATUS
      </Button>
      <Dialog open={showActionDialog}>
        <DialogTitle>Are you sure?</DialogTitle>
        <DialogContent>
          <TextField
            size="small"
            variant="outlined"
            select
            id="status-field"
            label="Status"
            value={status}
            onChange={(event) => setStatus(event.target.value)}
            fullWidth={true}
          >
            {amlStatuses.map((status) => {
              return (
                <MenuItem key={status.value} value={status.value}>
                  {status.label}
                </MenuItem>
              );
            })}
          </TextField>{" "}
          <br />
          <TextField
            variant="outlined"
            value={note}
            onChange={(event) => setNote(event.target.value)}
            label="Note"
            multiline
            rows={8}
          />
          {includeBankAccount && status === "Confirmed" && (
            <React.Fragment>
              <div>
                <TextField
                  variant="outlined"
                  value={bankAccount}
                  onChange={(event) => setBankAccount(event.target.value)}
                  label="Bank Account"
                />
              </div>
              <TextField
                size="small"
                variant="outlined"
                select
                id="status-field"
                label="Bank Name"
                value={bankName}
                onChange={(event) => setBankName(event.target.value)}
                fullWidth={true}
              >
                {painBanks.map((bank) => {
                  return (
                    <MenuItem key={bank.value} value={bank.value}>
                      {bank.label}
                    </MenuItem>
                  );
                })}
              </TextField>{" "}
            </React.Fragment>
          )}
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            color="primary"
            onClick={() => {
              setShowActionDialog(false);
              setAmlStatus();
            }}
          >
            Set
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={() => setShowActionDialog(false)}
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </ClaimsWrapper>
  );

  function setAmlStatus() {
    if (includeBankAccount && status === "Confirmed")
      setAmlWarningStatusAndCreateSendBackOrder(
        value,
        status,
        note,
        investorDepositId,
        bankAccount,
        bankName,
      );
    else setAmlWarningStatus(value, status, note);
  }
};
